// extracted by mini-css-extract-plugin
module.exports = {"cartlabels":"CartLabels-module--cartlabels--35xFs"};